import {computed, ComputedRef, effectScope, ref, Ref} from "vue";
import DocumentFAQButtons from "@/services/firebase/firestore/documents/DocumentFAQButtons";
import ModelFAQButtonLangSettings from "@models/v2/firebase/faq-buttons/ModelFAQButtonLangSettings";
import LangService from "@/services/LangService";

export class ServiceFAQButtons {
	private _scope = effectScope(true);
	private static _instance: ServiceFAQButtons | null = null;
	private _doc: Ref<DocumentFAQButtons | null> = ref(null);
	private readonly _loginViewButton: ComputedRef<ModelFAQButtonLangSettings | null>;
	private readonly _paymentsViewButton: ComputedRef<ModelFAQButtonLangSettings | null>;
	private readonly _settingsViewButton: ComputedRef<ModelFAQButtonLangSettings | null>;
	private _buttonsEnabled: Ref<boolean> = ref(import.meta.env.VITE_FAQ_BUTTONS === 'true')

	constructor() {
		const lang = LangService.getInstance().lang();

		this._loginViewButton = this._scope.run(() => computed(() => {
			if (this._doc.value !== null && !this._buttonsEnabled.value) return null;
			return this._doc.value?.loginView?.[lang.value == 'kk' ? 'kz' : lang.value] ?? null;
		})) as ComputedRef<ModelFAQButtonLangSettings | null>;

		this._paymentsViewButton = this._scope.run(() => computed(() => {
			if (this._doc.value !== null && !this._buttonsEnabled.value) return null;
			return this._doc.value?.paymentsView?.[lang.value == 'kk' ? 'kz' : lang.value] ?? null;
		})) as ComputedRef<ModelFAQButtonLangSettings | null>;

		this._settingsViewButton = this._scope.run(() => computed(() => {
			if (this._doc.value !== null && !this._buttonsEnabled.value) return null;
			return this._doc.value?.settingsView?.[lang.value == 'kk' ? 'kz' : lang.value] ?? null;
		})) as ComputedRef<ModelFAQButtonLangSettings | null>;
	}

	static of(): ServiceFAQButtons {
		if (ServiceFAQButtons._instance === null) {
			ServiceFAQButtons._instance = new ServiceFAQButtons();
		}

		return ServiceFAQButtons._instance;
	}

	public set buttonsEnabled(enabled: boolean) {
		this._buttonsEnabled.value = enabled;
	}

	public get loginViewButton() {
		return this._loginViewButton;
	}

	public get paymentsViewButton() {
		return this._paymentsViewButton;
	}

	public get settingsViewButton() {
		return this._settingsViewButton;
	}

	public setDataDoc(value: DocumentFAQButtons | null) {
		this._doc.value = value;
	}
}
